module.exports = __webpack_public_path__ + "static/uv-texture-61d76aee87c7843421b7254618a11b26.jpg";